import {Route, Switch} from "react-router-dom";
import OfferProductsList from "./OfferProductsList";
import OfferProductsView from "./OfferProductsView";


const App = ({match}) => (
    <Switch>
      <Route exact path={`${match.url}`} component={OfferProductsList}/>
      <Route path={`${match.url}/details/:id?`} component={OfferProductsView}/>
    </Switch>
);

export default App;